import React from 'react'
import { Helmet } from 'react-helmet'
import { withTranslation as translate } from 'react-i18next'
import Logo from './Logo'
import defaultConfig from '../services/config/default'

const Layout = ({ config, children, t }) => {
  const favicon = `/themes/${config.theme}/favicon.png`

  // Every route and query-string variant canonicalises to /profile on the
  // current host. Unknown hosts (local dev) get no canonical.
  const canonical = config === defaultConfig
    ? null
    : `https://${window.location.hostname}/profile`

  return (
    <>
      <Helmet>
        {
          // The theme name serves as a top level CSS class selector.
          // Effectively filters out all other theme styles.
        }
        <html class={config.theme} />

        <title>{t('signup.html_title')}</title>

        <link
          rel='shortcut icon'
          href={favicon}
          type='image/png'
        />

        {canonical && <link rel='canonical' href={canonical} />}
      </Helmet>

      <div className='container'>
        <div className='header'>
          <Logo config={config} />
        </div>
        {children}
      </div>
    </>
  )
}

export default translate()(Layout)
